<template>
  <div>
    <ul class="order_menu">
      <li :class="status == 99 ? 'active' : ''">
        <a href="javascript:void(0)" @click="orderTab(99,0)">全部订单</a>
      </li>
      <li :class="status == 0 ? 'active' : ''">
        <a href="javascript:void(0)" @click="orderTab(0,0)">待付款</a>
      </li>
      <li :class="status == 1 ? 'active' : ''">
        <a href="javascript:void(0)" @click="orderTab(1,0)">待发货</a>
      </li>
      <li :class="status == 2 ? 'active' : ''">
        <a href="javascript:void(0)" @click="orderTab(2,0)">已发货</a>
      </li>
      <li :class="status == 3 ? 'active' : ''">
        <a href="javascript:void(0)" @click="orderTab(3,0)">待评价</a>
      </li>
    </ul>
    <div class="no_result" v-if="total == 0">
      <img src="../../assets/images/icon_5.png" />
      <p>还没有任何订单呢</p>
      <router-link to="/">去挑选好物</router-link>
    </div>
    <div class="order_list" v-for="(item,indes) in orderArr" :key="indes">
      <div
        class="title"
      >下单时间：{{item.createTime | dateFormat}}&ensp;&ensp;&ensp;&ensp;订单号：{{item.orderSn}}</div>
      <ul class="goods">
        <template v-for="goods,indes in item.orderItemList">
          <li v-if="indes < 3">
            <img @click="onDetail(item.id)" :src="goods.productPic" />
          </li>
        </template>
      </ul>
      <div class="number">
        <em>共{{item.orderItemList.length}}种商品</em>
      </div>
      <div class="status">
        <em>
          <span v-if="item.status == 0">待付款</span>
          <span v-if="item.status == 1">待发货</span>
          <span v-if="item.status == 2">待收货</span>
          <span v-if="item.status == 3">待评价</span>
          <span v-if="item.status == 4">已完成</span>
          <span v-if="item.status == 5">已取消</span>
          <span v-if="item.status == 6">已关闭</span>
        </em>
      </div>
      <div class="price">
        <em>
          <span>￥{{item.payAmount}}</span>
          <span>（含运费：￥0.00元）</span>
        </em>
      </div>
      <div class="opera">
        <em>
          <!--  v-if="item.status == 3" -->
          <!-- <span v-if="item.status == 2"><a href="javascript:void(0)">申请售后</a></span> -->
          <span v-if="item.status == 3">
            <a href="javascript:void(0)" @click="orderEval(item.id)">评价</a>
          </span>
          <span v-if="item.status == 0">
            <a href="javascript:void(0)" @click="payCompo(item.id,item.payType)">付款</a>
          </span>
          <span v-if="item.status == 0">
            <a href="javascript:void(0)" @click="orderCancel(item.id)">取消订单</a>
          </span>
          <span v-if="item.status > 1 && item.status < 5">
            <a
              href="javascript:void(0)"
              @click="orderCourier(item.deliverySn,item.deliveryCompany)"
            >查看物流</a>
          </span>
          <span v-if="item.status == 2">
            <a href="javascript:void(0)" @click="orderSure(item.id)">确认收货</a>
          </span>
          <span>
            <a href="javascript:void(0)" @click="onDetail(item.id)">查看详情</a>
          </span>
        </em>
      </div>
    </div>
    <!-- 分页 -->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagenum"
      :page-size="pagesize"
      layout="total, prev, pager, next"
      :total="total"
      :hide-on-single-page="true"
    ></el-pagination>
    <!-- 分页 -->
    <!-- 查看物流 -->
    <div class="yu_mask" v-if="orderCourierShow == 1">
      <div class="order_courier">
        <h3 class="title">追踪物流</h3>
        <div class="icon">
          <i></i>
          <p>
            物流公司：
            <span>顺分速运</span>
          </p>
          <p>
            快递单号：
            <span>1231654564564</span>
          </p>
        </div>
        <div class="courier">
          <ul>
            <li v-for="(item, index) in courierArr" :key="index">
              <span>
                <p style="color: #333">{{courierSplit(item.AcceptTime)[0]}}</p>
                <p style="color: #999">{{courierSplit(item.AcceptTime)[1]}}</p>
              </span>
              <div>{{item.AcceptStation}}</div>
            </li>
          </ul>
        </div>
        <div class="btns_close" @click="orderClose">确定</div>
      </div>
      <div class="yu_back" @click="orderClose"></div>
    </div>
    <!-- 查看物流 -->
  </div>
</template>

<script>
import { orderList, orderCancel, orderReceive } from '@/api/order'
import { webWechatPay, webAlipay } from '@/api/pay'
import { expreessInquiry } from '@/api/aliyun'
export default {
  name: "orderList",
  data() {
    return {
      id: "",
      orderArr: [],
      status: 99, // 当前状态
      total: 0, // 订单数量
      pagenum: 1, // 当前页码
      pagesize: 5, // 每页条数
      orderCourierShow: 0, // 查看物流
      objData:
        '{"LogisticCode":"806544275256599247","ShipperCode":"SF","Traces":[{"AcceptStation":"【福建省福州市闽清县公司】 已收件","AcceptTime":"2019-06-21 18:12:14"},{"AcceptStation":"【福建省福州市闽清县】 已发出 下一站 【福州转运中心】","AcceptTime":"2019-06-22 14:49:02"},{"AcceptStation":"【福州转运中心】 已收入","AcceptTime":"2019-06-22 20:39:36"},{"AcceptStation":"【福州转运中心】 已发出 下一站 【北京转运中心】","AcceptTime":"2019-06-22 20:43:27"},{"AcceptStation":"【北京转运中心】 已收入","AcceptTime":"2019-06-24 08:33:33"},{"AcceptStation":"【北京转运中心】 已发出 下一站 【北京市朝阳区黄港公司】","AcceptTime":"2019-06-24 08:35:51"},{"AcceptStation":"【北京市朝阳区黄港公司】 已收入","AcceptTime":"2019-06-24 08:46:24"},{"AcceptStation":"【北京市朝阳区黄港公司】 派件人: 宋军龙 派件中 派件员电话18521852053","AcceptTime":"2019-06-24 13:34:16"},{"AcceptStation":"客户 签收人: 王静宇 已签收 感谢使用圆通速递，期待再次为您服务","AcceptTime":"2019-06-24 15:40:42"}],"State":"3","Success":true,"Courier":"","CourierPhone":""}',
      courierArr: [] // 物流记录
    };
  },
  created() {
    let courier = JSON.parse(this.objData);
    this.courierArr = courier.Traces.reverse();
    console.log(this.$route.query.key);
    this.$emit("getUser", this.$route.query.key);
    this.orderTab(99);
  },
  methods: {
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.pagesize = val;
      this.pagenum = 1;
      this.orderTab(this.status);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.pagenum = val;
      this.orderTab(this.status);
    },
    orderTab(status, page) {
      let _this = this;
      console.log(page);
      page == 0 ? (_this.pagenum = 1) : "";
      _this.status = status;
      if (status == 99) {
        orderList({
          pageSize: _this.pagesize,
          pageNum: _this.pagenum
        }).then(function(res) {
          console.log(res);
          if (res.code == 200) {
            _this.orderArr = res.data.list;
            _this.total = res.data.total;
          }
        });
      } else {
        orderList({
          pageSize: _this.pagesize,
          pageNum: _this.pagenum,
          status: status
        }).then(function(res) {
          console.log(res);
          if (res.code == 200) {
            _this.orderArr = res.data.list;
            _this.total = res.data.total;
          }
        });
      }
    },
    // 付款
    async payCompo(orderSn, payType) {
      let _this = this;
      if (payType == 0) {
        // 支付宝支付
        const res = await webAlipay({
          out_trade_no: orderSn
        });
        console.log(res);
        if (res.code == 200) {
          let router = _this.$router.resolve({
            path: "payali",
            query: {
              orderid: orderSn,
              result: res.data
            }
          });
          window.open(router.href, "_blank");
        }
        // 支付宝支付
        // _this.$http
        //   .get(`/pay/alipay/getWebAlipay?out_trade_no=${orderSn}`)
        //   .then(res => {
        //     console.log(res);
        //     let routeData = _this.$router.resolve({
        //       path: "payali",
        //       query: {
        //         orderid: orderSn,
        //         result: res.data.data
        //       }
        //     });
        //     window.open(routeData.href, "_blank");
        //   });
      } else {
        // 微信支付
        const res = await webWechatPay({
          out_trade_no: orderSn
        });
        console.log(res);
        if (res.code == 200) {
          let router = _this.$router.resolve({
            path: "paywx",
            query: {
              orderid: orderSn,
              result: res.data
            }
          });
          window.open(router.href, "_blank");
        }
        // 微信支付
        // _this.$http
        //   .get(`/pay/wechat/getWebWechatPay?out_trade_no=${orderSn}`)
        //   .then(res => {
        //     console.log(res);
        //     let routeData = _this.$router.resolve({
        //       path: "paywx",
        //       query: {
        //         orderid: orderSn,
        //         result: res.data.data
        //       }
        //     });
        //     window.open(routeData.href, "_blank");
        //   });
      }
    },
    // 取消订单
    orderCancel(orderSn){
      this.$confirm("此操作将取消订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(async () => {
        const res = await orderCancel(orderSn)
        console.log(res)
        if (res.code == 200) {
          console.log(res.data)
          this.orderTab(this.status);
        }
        // const res = await this.$http.post(`/order/cancel/${id}`);
        // const {
        //   data: { code, data, message }
        // } = res;
        // console.log(res);
        // if (code == 200) {
        //   console.log(data);
        //   this.orderTab(this.status);
        // }
        this.$message({
          type: "success",
          message: "删除成功!"
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    // 查看详情
    onDetail(id) {
      let router = this.$router.resolve({
        path: "/orderDetail",
        query: {
          id: id,
          key: 2
        }
      });
      window.open(router.href, "_blank");
    },
    // 查看物流
    orderCourier(sn, cm) {
      console.log(sn);
      console.log(cm);
      this.orderCourierShow = 1;
      this.courierDetail(sn,cm)
    },
    // 物流详情
    async courierDetail(sn,cm){
      const res = await expreessInquiry({
        courierNumber: sn,
        courierCompany: cm
      })
      console.log(res)
      if (res.code == 200) {
        console.log(res.data)
        let courier = JSON.parse(res.data)
        this.courierArr = courier.Traces.reverse()
      }
      // const res = await this.$http.post(`/aliyun/oss/expreessInquiry?courierNumber=${sn}&courierCompany=${cm}`);
      // const {
      //   data: { code, data, message }
      // } = res;
      // console.log(res)
      // if (code == 200) {
      //   console.log(data)
      //   let courier = JSON.parse(data)
      //   this.courierArr = courier.Traces.reverse()
      // }
    },
    courierSplit(name) {
      return name.split(" ");
    },
    // 关闭物流弹窗
    orderClose() {
      this.orderCourierShow = 0;
    },
    // 确认收货
    orderSure(id){
      this.$confirm("是否确认收货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(async () => {
        const res = await orderReceive(id)
        console.log(res)
        if (res.code == 200) {
          console.log(res.data)
          this.orderTab(this.status)
        }
        // const res = await this.$http.post(`/order/receive/${id}`);
        // const {
        //   data: { code, data, message }
        // } = res;
        // console.log(res);
        // if (code == 200) {
        //   console.log(data);
        //   this.orderTab(this.status);
        // }
        this.$message({
          type: "success",
          message: "收货成功!"
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "取消收货"
        });
      });
    },
    // 评价
    orderEval(id) {
      this.$router.push({
        path: "/evalGoods",
        query: {
          id: id,
          key: 2
        }
      });
    }
  }
};
</script>

<style scoped>
.order_menu {
  float: left;
  height: 40px;
  border-bottom: 2px solid #eaeaea;
  margin-bottom: 21px;
}
.order_menu li {
  float: left;
  width: 110px;
  height: 40px;
  text-align: center;
  padding: 10px 0;
  margin-bottom: -2px;
  position: relative;
  z-index: 2;
  cursor: pointer;
}
.order_menu li a {
  display: block;
  color: #333;
  font-size: 18px;
  font-weight: bold;
  height: 18px;
  border-left: 1px solid #eaeaea;
}
.order_menu li:first-child a {
  border: none;
}
.order_menu li a:hover {
  color: #b4a078;
}
.order_menu li.active {
  border-bottom: 2px solid #b4a078;
}
.order_menu li.active a {
  color: #b4a078;
}
.order_list {
  width: 100%;
  height: 208px;
  margin-bottom: 21px;
  border: 1px solid rgba(218, 218, 218, 1);
  overflow: hidden;
}
.order_list .title {
  float: left;
  width: 100%;
  height: 48px;
  line-height: 48px;
  color: #666;
  padding-left: 21px;
  border-bottom: 1px solid rgba(218, 218, 218, 1);
  background: rgba(245, 245, 245, 1);
}
.order_list em {
  height: 160px;
  font-style: normal;
  display: table-cell;
  vertical-align: middle;
}
.order_list .goods {
  float: left;
  width: 390px;
  padding: 24px 0 24px 20px;
}
.order_list .goods li {
  float: left;
  width: 110px;
  height: 110px;
  margin-right: 12px;
}
.order_list .goods li img {
  float: left;
  width: 110px;
  height: 110px;
  cursor: pointer;
}
.order_list .number {
  float: left;
  width: 148px;
  color: #333;
  text-align: center;
}
.order_list .number em {
  width: 148px;
}
.order_list .status {
  float: left;
  width: 140px;
  color: #ff3232;
  text-align: center;
}
.order_list .status em {
  width: 140px;
}
.order_list .price {
  float: left;
  width: 156px;
  text-align: center;
  border-left: 1px solid rgba(218, 218, 218, 1);
}
.order_list .price em {
  width: 156px;
}
.order_list .price span {
  display: block;
  padding: 8px 0;
}
.order_list .opera {
  float: left;
  width: 146px;
  text-align: center;
  border-left: 1px solid rgba(218, 218, 218, 1);
}
.order_list .opera em {
  width: 146px;
}
.order_list .opera span {
  display: block;
}
.order_list .opera span a {
  color: #69c;
  line-height: 22px;
}
.el-pagination {
  float: right;
  margin: 0 0 50px;
}
/* 查看物流 */
.yu_mask .order_courier {
  width: 612px;
  height: 574px;
  margin: 0 auto;
  padding: 40px 60px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  margin-top: -287px;
  z-index: 245;
}
.yu_mask .order_courier .title {
  font-size: 20px;
  color: rgba(51, 51, 51, 1);
  padding-bottom: 40px;
}
.yu_mask .order_courier .icon {
  height: 50px;
  margin-bottom: 24px;
  overflow: hidden;
}
.yu_mask .order_courier .icon i {
  float: left;
  width: 50px;
  height: 50px;
  margin-right: 20px;
  background: url("../../assets/images/icon_0.png") -30px -157px no-repeat;
}
.yu_mask .order_courier .icon p {
  float: left;
  width: 400px;
  color: #333;
  line-height: 24px;
}
.yu_mask .order_courier .icon p span {
  display: inline-block;
  color: #999;
  line-height: 24px;
}
.yu_mask .order_courier .courier {
  width: 100%;
  height: 292px;
  padding: 16px 0;
  border-top: solid 1px #dadada;
  border-bottom: solid 1px #dadada;
  margin-bottom: 24px;
  overflow: hidden;
}
.yu_mask .order_courier .courier ul {
  width: 100%;
  height: 256px;
  overflow-y: auto;
  overflow-x: hidden;
}
.yu_mask .order_courier .courier ul li {
  float: left;
  width: 100%;
  padding-bottom: 10px;
  position: relative;
}
.yu_mask .order_courier .courier ul li::after {
  content: "";
  width: 1px;
  height: 100%;
  border-left: dashed 1px #dadada;
  overflow: hidden;
  position: absolute;
  top: 5px;
  left: 90px;
}
.yu_mask .order_courier .courier ul li:last-child:after {
  height: 0;
}
.yu_mask .order_courier .courier ul li span {
  float: left;
  width: 96px;
  position: relative;
  z-index: 9;
}
.yu_mask .order_courier .courier ul li span::after {
  content: "";
  width: 10px;
  height: 11px;
  background: url("../../assets/images/icon_0.png") -79px -135px no-repeat;
  position: absolute;
  top: 5px;
  right: 0;
}
.yu_mask .order_courier .courier ul li:first-child span::after {
  background-position: -79px -146px;
}
.yu_mask .order_courier .courier ul li span p {
  display: block;
  line-height: 24px;
}
.yu_mask .order_courier .courier ul li div {
  float: left;
  color: #333;
  width: 365px;
  line-height: 24px;
  padding-left: 10px;
  cursor: pointer;
}
.yu_mask .order_courier .btns_close {
  width: 144px;
  height: 42px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  background: rgba(180, 160, 120, 1);
  border-radius: 2px;
  margin: 0 auto;
}
.no_result p {
  padding: 23px 0 7px;
}
.no_result a {
  color: #69c;
  font-size: 16px;
}
</style>